import { getGazeSurveyUrl } from "./gazeReportSurvey";

/*
 * iframeTemplate.js — Gaze Report v6 production iframe shell.
 *
 * Parallels the Mobility pattern: this file CONTAINS the report HTML shell, injects the
 * adapted view model as a global, and links the runtime assets from /gaze-report/. The React
 * wrapper (GazeReport.js) renders the returned string via <iframe srcDoc=...>. The report
 * design/behavior lives entirely in /gaze-report/app.js + gaze.css — so production and the
 * standalone share one implementation.
 */
const ASSET_BASE = "/gaze-report";
// Report languages with a translation table in /gaze-report/gaze-strings.js.
const REPORT_LOCALES = ["en", "ja", "zh"];

const escapeScriptJson = (value) =>
  JSON.stringify(value == null ? {} : value)
    .replace(/</g, "\\u003c")
    .replace(/\u2028|\u2029/g, "");

export const buildGazeReportSrcDoc = (
  reportData,
  locale = "en",
  frameNonce = "",
) => `<!DOCTYPE html>
<html lang="${REPORT_LOCALES.includes(locale) ? locale : "en"}">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
  <meta name="referrer" content="no-referrer" />
  <title>Gaze Response Report</title>
  <link rel="stylesheet" href="${ASSET_BASE}/gaze.css" />
</head>
<body>
  <div id="gaze-app"></div>
  <script>
    function gazeReportBack() {
      window.parent.postMessage(
        {
          type: "seniorlife:gaze-report-back",
          frameNonce: ${escapeScriptJson(frameNonce)}
        },
        "*"
      );
    }
    function gazeReportSurvey(url) {
      window.parent.postMessage(
        {
          type: "seniorlife:gaze-report-survey",
          url: url,
          frameNonce: ${escapeScriptJson(frameNonce)}
        },
        "*"
      );
    }
  </script>
  <!-- Injected, already-adapted view model (production passes viewModel, not raw). -->
  <script>var GAZE_DATA = { viewModel: ${escapeScriptJson(reportData)} };</script>
  <script>var GAZE_LOCALE = ${JSON.stringify(REPORT_LOCALES.includes(locale) ? locale : "en")};</script>
  <script>var GAZE_SURVEY_URL = ${escapeScriptJson(getGazeSurveyUrl(locale))};</script>
  <script src="${ASSET_BASE}/gaze-strings.js"></script>
  <script src="${ASSET_BASE}/app.js"></script>
</body>
</html>`;

export default buildGazeReportSrcDoc;
